import { render, staticRenderFns } from "./OnboardingTimeline.vue?vue&type=template&id=06547603&scoped=true&"
import script from "./OnboardingTimeline.vue?vue&type=script&lang=js&"
export * from "./OnboardingTimeline.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTimeline.vue?vue&type=style&index=0&id=06547603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06547603",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
